import { useState } from "react";
import { useAuth } from "../../lib/auth";
import api from "../../lib/api";
import { toast } from "sonner";

export default function Profile() {
    const { user, refreshMe } = useAuth();
    const [addr, setAddr] = useState({
        label: "Home",
        line1: "",
        line2: "",
        city: "",
        country: "AE",
        postal_code: "",
    });
    const [busy, setBusy] = useState(false);

    const saveAddr = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await api.post("/me/addresses", addr);
            toast.success("Address added");
            await refreshMe();
            setAddr({ ...addr, line1: "", line2: "", city: "", postal_code: "" });
        } catch (e) {
            toast.error("Could not save");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="space-y-8">
            <div className="lx-label text-[#B2912A]">Profile</div>
            <h1 className="font-serif text-4xl text-[#180A21]">{user?.name}</h1>

            <div className="grid lg:grid-cols-12 gap-8">
                <div className="lx-card p-7 lg:col-span-5">
                    <div className="lx-label text-[#B2912A] mb-4">Account</div>
                    <Row label="Email" value={user?.email} />
                    <Row label="Phone" value={user?.phone || "—"} />
                    <Row label="Role" value={user?.role} />
                </div>

                <div className="lg:col-span-7 space-y-4">
                    <div className="lx-card p-7">
                        <div className="lx-label text-[#B2912A] mb-4">Saved addresses</div>
                        {(user?.addresses || []).length === 0 ? (
                            <div className="text-sm text-[#555] mb-4">
                                Add an address to start booking.
                            </div>
                        ) : (
                            <div className="space-y-2 mb-6">
                                {user.addresses.map((a) => (
                                    <div
                                        key={a.id}
                                        className="p-3 bg-[#FAFAF8] border border-[#E5E2DC]"
                                    >
                                        <div className="lx-label text-[#B2912A]">{a.label}</div>
                                        <div className="text-sm text-[#180A21]">{a.line1}</div>
                                        {a.line2 && (
                                            <div className="text-sm text-[#555]">{a.line2}</div>
                                        )}
                                        <div className="text-xs text-[#555] mt-1">
                                            {a.city}, {a.country}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                        <form onSubmit={saveAddr} className="space-y-3 pt-4 border-t border-[#F3F2F0]">
                            <div className="lx-label text-[#555]">Add new address</div>
                            <div className="grid grid-cols-2 gap-3">
                                <input
                                    placeholder="Label (Home/Office)"
                                    value={addr.label}
                                    onChange={(e) => setAddr({ ...addr, label: e.target.value })}
                                    className="lx-input"
                                    data-testid="addr-label"
                                />
                                <input
                                    placeholder="City"
                                    value={addr.city}
                                    onChange={(e) => setAddr({ ...addr, city: e.target.value })}
                                    required
                                    className="lx-input"
                                    data-testid="addr-city"
                                />
                            </div>
                            <input
                                placeholder="Address line 1"
                                value={addr.line1}
                                onChange={(e) => setAddr({ ...addr, line1: e.target.value })}
                                required
                                className="lx-input"
                                data-testid="addr-line1"
                            />
                            <input
                                placeholder="Address line 2 (optional)"
                                value={addr.line2}
                                onChange={(e) => setAddr({ ...addr, line2: e.target.value })}
                                className="lx-input"
                            />
                            <div className="grid grid-cols-2 gap-3">
                                <input
                                    placeholder="Country (e.g. AE)"
                                    value={addr.country}
                                    onChange={(e) => setAddr({ ...addr, country: e.target.value })}
                                    className="lx-input"
                                />
                                <input
                                    placeholder="Postal code"
                                    value={addr.postal_code}
                                    onChange={(e) =>
                                        setAddr({ ...addr, postal_code: e.target.value })
                                    }
                                    className="lx-input"
                                />
                            </div>
                            <button
                                disabled={busy}
                                type="submit"
                                data-testid="addr-save-btn"
                                className="lx-btn-primary px-5 py-2.5"
                            >
                                Save address
                            </button>
                        </form>
                    </div>
                </div>
            </div>
            <style>{`.lx-input{width:100%;padding:.7rem 1rem;background:white;border:1px solid #E5E2DC;outline:none;transition:all 200ms ease;font-size:.875rem}.lx-input:focus{border-color:#D4AF37;box-shadow:0 0 0 1px #D4AF37}`}</style>
        </div>
    );
}

function Row({ label, value }) {
    return (
        <div className="py-3 border-b border-[#F3F2F0] last:border-0 flex justify-between items-center">
            <span className="lx-label text-[#555]">{label}</span>
            <span className="text-sm text-[#180A21]">{value}</span>
        </div>
    );
}
